import { fieldMappings } from 'components/transaction/components/panels/transaction/announcements/announcementsConfig';
import { put, select } from 'redux-saga/effects';
import { AUTOMATION_SOURCE } from 'utils/constants';
import { selectFormById } from '../../formControlSelectors';
import { formControlActions, getSourceValue } from '../../formControlSlice';

export function* copyBisonAnnouncementHandler({ payload: { transactionId, tableName: table, announcementValues, key, copy } }) {
    const tableName = copy ? table : '';
    const internalIdAnnouncementUsed = copy ? key : '';
    const form = yield select(selectFormById(transactionId));
    if (!form) return;

    const fields = form?.formConfig?.fields || [];
    const fieldWrites = [];
    for (const { dataField: fieldName, lookup, editable } of fields) {
        if (!editable || fieldName === 'sendToBison') continue;
        const dataFieldToRead = fieldMappings[fieldName];
        if (!dataFieldToRead) continue;
        const newFieldValue = getSourceValue(announcementValues, dataFieldToRead, lookup);
        if (!newFieldValue || typeof newFieldValue === 'object') continue;
        fieldWrites.push({ fieldName, newFieldValue });
    }

    // The newest selection: a row copy still loading must not land over the fields this announcement
    // writes. One that fills nothing leaves it alone.
    if (fieldWrites.length) yield put(formControlActions.cancelCopies({ formId: transactionId }));

    for (const { fieldName, newFieldValue } of fieldWrites) {
        // The value now comes from the announcement, not the agent, so later autofill may replace it.
        yield put(formControlActions.clearUserEdited({ formId: transactionId, fieldName }));
        yield put(formControlActions.setFieldValue({ formId: transactionId, fieldName, value: newFieldValue }));
        yield put(formControlActions.setFieldValueSource({ formId: transactionId, fieldName, source: AUTOMATION_SOURCE.BISON_ANNOUNCEMENT }));
        yield put(formControlActions.setFieldError({ formId: transactionId, fieldName, error: false }));
    }

    yield put(formControlActions.setActiveSelectionTableName({ formId: transactionId, tableName }));
    yield put(formControlActions.setAnnouncementIdUsed({ formId: transactionId, internalIdAnnouncementUsed }));
    if (copy) {
        yield put(formControlActions.setFieldValue({ formId: transactionId, fieldName: 'sendToBison', value: true }));
    }
    yield put(formControlActions.validateTransactionWithInventoryData({ formId: transactionId }));
}
